import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { AUTHENTICATION_SUCCESS } from '../constants/messages';
import { toastError, toastClear } from '../actions/toast';
import { getChatCredentials } from '../actions/chat';
import { setCurrentFarm } from './farm';
import { setToken, setUserInfo, setPermission, setLoginStatus } from '../helpers/session';
import { TOKEN_EXPIRED, LOGOUT, LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SET_QR_SECERET_KEYS } from '../constants/action-types';
import { LOAD_TYPE, LOGIN_STATUS } from '../constants';
import { getFarmOrganization } from './organization';

const toastOptions = { position: "top-left" };

export const loginRequest = () => ({ type: LOGIN_REQUEST });

export const loginSuccess = data => ({ type: LOGIN_SUCCESS, payload: data });

export const loginFailure = error => ({ type: LOGIN_FAILURE, error });

export const tokenExpired = () => ({ type: TOKEN_EXPIRED });

export const logout = data => ({ type: LOGOUT, payload: data });

export const setQrKeys = (data) => ({ type: SET_QR_SECERET_KEYS, payload: data });

export const login = (params, history) => dispatch => {
    dispatch(loginRequest());
    dispatch(toastClear());
    defaultAgent.post('/api/user/signin', {
        login: params.login,
        password: params.password,
        include_permission: true,
        is_allow_single_user: true,
        include_user_role: true,
        __version: 1
    }).then(res => {
        const loginRes = apiResponse(res, {});

        if (loginRes.code === AUTHENTICATION_SUCCESS.code) {
            const loginInfo = loginRes.data;
            defaultAgent.setToken(loginInfo.access_token);

            const userInfo = {
                userId: loginInfo.user_id,
                loginId: params.login,
                //accessKey: params.password,
                showResetPassword: !loginInfo.password_reset,
                ...loginInfo.role_id && {
                    role_id: loginInfo.role_id,
                    role_name: loginInfo.role_name
                }
            };

            const farmInfo = {
                ...loginInfo.farm,
                farm_name: loginInfo.farm.farm_name ? loginInfo.farm.farm_name : loginInfo.farm.name,
                load_type: (loginInfo.farm.load_type || LOAD_TYPE.MANUAL),
                //db_harvest_projection: loginInfo.farm && loginInfo.farm.is_harvest_projection_enable ? loginInfo.farm.is_harvest_projection_enable : true
            };

            //------- STORE THE USER LOGIN INFO INTO LOCAL STORAGE---------------
            setUserInfo(userInfo);
            setLoginStatus(LOGIN_STATUS.loggedIn);
            setToken(loginInfo.access_token);
            setPermission(loginInfo.permission);
            //-------------------------------------------------------------------

            dispatch(getFarmOrganization(loginInfo.farm.farm_uuid, (organizationData) => {
                if (!organizationData) return;
                dispatch(setCurrentFarm(farmInfo));
                dispatch(loginSuccess(userInfo));
                dispatch(getChatCredentials());
                if (history) history.push(`/home/farm/${loginInfo.farm.farm_uuid}/map`);
            }));
        } else {
            dispatch(loginFailure(loginRes.message));
            dispatch(toastError(loginRes.message));
        }
    }).catch(ex => {
        dispatch(loginFailure(ex.message));
        dispatch(toastError(ex.message));
    });
}

export const oauthLogin = (params, history, cb) => dispatch => {
    dispatch(loginRequest());
    dispatch(toastClear());
    defaultAgent.post('/api/user/oauth', {
        login: params.login,
        provider: params.provider,
        include_permission: true
    }).then(res => {
        const loginRes = apiResponse(res, {});

        if (loginRes.code === AUTHENTICATION_SUCCESS.code) {
            const loginInfo = loginRes.data;
            defaultAgent.setToken(loginInfo.access_token);

            const userInfo = {
                userId: loginInfo.user_id,
                loginId: params.login,
                //accessKey: params.password,
                showResetPassword: !loginInfo.password_reset
            };

            const farmInfo = {
                ...loginInfo.farm,
                farm_name: loginInfo.farm.farm_name ? loginInfo.farm.farm_name : loginInfo.farm.name,
                load_type: (loginInfo.farm.load_type || LOAD_TYPE.MANUAL)
            };

            //------- STORE THE USER LOGIN INFO INTO LOCAL STORAGE---------------
            setUserInfo(userInfo);
            setLoginStatus(LOGIN_STATUS.loggedIn);
            setToken(loginInfo.access_token);
            setPermission(loginInfo.permission);
            //-------------------------------------------------------------------

            dispatch(getFarmOrganization(loginInfo.farm.farm_uuid, (organizationData) => {
                if (!organizationData) return;
                dispatch(setCurrentFarm(farmInfo));
                dispatch(loginSuccess(userInfo));
                dispatch(getChatCredentials());
                if (history) history.push(`/home/farm/${loginInfo.farm.farm_uuid}/map`);
            }));
        } else {
            if (cb) cb();
            dispatch(loginFailure(loginRes.message));
            dispatch(toastError(loginRes.message));
        }
    }).catch(ex => {
        if (cb) cb();
        dispatch(loginFailure(ex.message));
        dispatch(toastError(ex.message));
    });
}

export const getQRSeceretKeys = () => dispatch => {
    defaultAgent.get('/api/auth/qrcode/secretkeys')
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message, toastOptions));
                dispatch(setQrKeys({}));
            } else if (agentResult.data) {
                dispatch(setQrKeys(agentResult.data));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message, toastOptions));
            dispatch(setQrKeys({}));
        });
};